import { usePlatformFlags } from './usePlatformFlags';

/** Key of the global release flag (henry-rollins) that swaps performance-stats for the new Insights page. */
export const INSIGHTS_FLAG = 'insights';

/**
 * Whether the `insights` release flag is on for this environment.
 *
 * False until the first poll lands and whenever the flags endpoint fails, so the
 * existing performance-stats page stays the fallback.
 */
export const useIsInsightsEnabled = (): boolean => usePlatformFlags()[INSIGHTS_FLAG] === true;
